/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Type recurrency kind of the charging profile
 */
export enum ChargePointChargingProfileRecurrencyKindType {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY'
}
